import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-down-arrow\">\n    <path fill-rule=\"evenodd\" d=\"M4.72 6.305l3.279 3.281 3.306-3.305L12 7l-3.294 3.293.013.012L8 11 4 7l.72-.695z\" opacity=\".3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol